export const ZOHO_CRM_INTEGRATION_SUMMARY_INTRO =
  "Everything's built and ready to go! Here's a summary of what was created:"

export const ZOHO_CRM_INTEGRATION_SUMMARY_BODY =
  '19 files across a clean, layered FastAPI project at `/DOSense/agent/home/salesforce-integration/`.'

export const ZOHO_CRM_INTEGRATION_ENDPOINT_TABLE_DATA = [
  { Method: 'GET', Path: '/auth', Purpose: 'Start Salesforce OAuth2 flow' },
  { Method: 'GET', Path: '/auth/callback', Purpose: 'Exchange code for tokens' },
  { Method: 'GET', Path: '/auth/status', Purpose: 'Check if authenticated' },
  { Method: 'POST', Path: '/leads', Purpose: 'Submit a form → Salesforce Lead' },
  { Method: 'GET', Path: '/leads', Purpose: 'Paginated lead list' },
  { Method: 'POST', Path: '/leads/{id}/convert', Purpose: 'Convert lead → Contact + Opportunity' },
  { Method: 'POST', Path: '/contacts', Purpose: 'Upsert contact by email' },
  { Method: 'POST', Path: '/opportunities', Purpose: 'Create order → Salesforce Opportunity' },
  { Method: 'PATCH', Path: '/opportunities/{id}', Purpose: 'Update stage/amount' },
  { Method: 'POST', Path: '/products', Purpose: 'Single product upsert by SKU' },
  { Method: 'POST', Path: '/products/bulk-sync', Purpose: 'Sync up to 200 products' },
  { Method: 'POST', Path: '/webhook', Purpose: 'Receive Salesforce → website events' },
]

export const ZOHO_CRM_INTEGRATION_KEY_DESIGN_ITEMS = [
  'Auto token refresh — access tokens rotate silently; never expires mid-request',
  'Upsert by email (contacts) and by SKU (products) — no accidental duplicates',
  'Line-item amount calculation is deterministic Python, never left to the CRM',
  'Webhook handler is pre-wired with stub methods ready for your business logic',
]

export const ZOHO_CRM_INTEGRATION_WRAP_UP_MARKDOWN =
  '✅ **Integration complete.** The FastAPI Salesforce CRM layer is ready — open the README artifact for endpoint details and next steps.'

/**
 * @param {string} artifactId
 * @returns {object[]}
 */
